import React from 'react'
import HeaderOne from '../../common/header/HeaderOne'
import CustomFooter from "../../elements/CustomFooter/CustomFooter";
import Copyright from '../../common/footer/Copyright'
import './style.css'
import SEO from '../../common/SEO';

function SEOpage() {
  return (
    <>
      <SEO title="About Us" />
      <main className="page-wrapper">
        <HeaderOne btnStyle="btn-small round btn-icon" HeaderSTyle="header-transparent66" />
        <div className="slider-area slider-style-1 height-380 bg_image" data-black-overlay="1" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/bg/ac43fa309cf251e8267283091e8bea0268e3d968-1381x548.jpg)` }}>
        </div>
        <div className='main_container_for_services'>
          <div className='inner_container_for_services'>
            <div style={{ height: '8px', width: '60px', background: '#00C896', marginBottom: '2rem' }}></div>
            <h1>Search Engine Optimization</h1>
            <p style={{ marginBottom: '3.5rem' }}>#1 SEO SERVICES AGENCY IN UTTARPRADESH</p>
            <p style={{ marginBottom: '3.5rem' }}>Looking for first page rankings? Need more relevant traffic and a higher conversion rate through SEO? To draw potential customers to your website, you need fool-proof India SEO Services that are not just effective but sharp enough to put you a cut above your competition.</p>
            <h3>India SEO Services</h3>
            <p style={{ marginBottom: '3.5rem' }}>When you choose an expert online marketing company like YGS Web Solutions, you're making a long-term strategic investment in your online presence and reach. Improving your website's organic search rankings is a time-consuming and technical process, which must be done well to yield the desired results. Our India SEO Consultant team has the expertise to bring your website to the top when potential customers search for your products or services.</p>
            <h3>Our YGS Web Solutions SEO India Commitments:</h3>
            <ul style={{ listStyleType: 'square' }}>
              <li>Best SEO Practices</li>
              <li>Most Keywords In Top Organic SEO Results</li>
              <li>Increased Web Traffic</li>
              <li>More Sales Queries</li>
            </ul>
            <h3>WHAT MAKES India SEO SERVICES THE ULTIMATE CHOICE FOR PROMOTING YOUR BUSINESS?</h3>
            <ul style={{ listStyleType: 'square' }}>
              <li>92% of online users initiate their internet activity through search engines such as Google.</li>
              <li>Search traffic is 300% greater than social media traffic.</li>
              <li>75% of search users don’t bother going past the first page of results.</li>
              <li>78% of Canadians ignore or avoid clicking on PPC ads - organic rules the roost!</li>
              <li>Local searches account for 40% of total search activity.</li>
              <li>92% of all local searches end up in a purchase or sale.</li>
              <li>54% of Canadians prefer internet searches over phone directories to find a local service</li>
            </ul>
            <h3>Five strategic pillars of our SEO services in India</h3>
            <p style={{ marginBottom: '3.5rem' }}>Effective SEO requires planning, research, and a comprehensive understanding of your business industry and goals. As an expert India SEO Agency, we do our homework, so we can create an SEO strategy that will be effective. We consider:</p>
            <h4>1-What are you selling?</h4>
            <p style={{ marginBottom: '3.5rem' }}>We seek to understand your products and services, so we can promote them in the best way, with the right keywords to get the desired results.</p>
            <h4>2-Who is your target audience?</h4>
            <p style={{ marginBottom: '3.5rem' }}>We must define the demographics of your audience, so we can reach the right people with the most effective keywords and content.</p>
            <h4>3-Where is your market?</h4>
            <p style={{ marginBottom: '3.5rem' }}>A generalized marketing strategy is costly. We focus on comprehensive, area-based marketing strategies to maximize your ROI.</p>
            <h4>4-How will we achieve success?</h4>
            <p style={{ marginBottom: '3.5rem' }}>Once we learn what, who, and where, we focus on how to best promote your business. Based on our findings, we outline a detailed SEO plan following the best India SEO practices.</p>
            <h4>5-What is working?</h4>
            <p style={{ marginBottom: '3.5rem' }}>As the SEO strategy is implemented, we monitor and observe how each activity is performing, to determine whether we should keep, modify, or remove it from the plan, so we can continue to improve the SEO results.</p>
            <h3>Why You Need Local SEO</h3>
            <ul style={{ listStyleType: 'square' }}>
              <li>Your visibility in local search results will improve.</li>
              <li>Mobile visibility will increase via map listings.</li>
              <li>You will get more local traffic to your website.</li>
              <li>Sales leads will increase.</li>
              <li>The likelihood of conversions will increase, because local searchers are more serious buyers.</li>
            </ul>
            <p style={{ marginBottom: '3.5rem' }}>Your customers will create more sales opportunities by posting their reviews about you</p>
          </div>
          <div className='thirdy_container_for_services'>
            <img src={`${process.env.PUBLIC_URL}/images/banner/a170723b097df2ec7ffbff8f342350933ce09307-581x552.jpg`} />
          </div>
        </div>
      </main>
      <CustomFooter />
    </>
  )
}

export default SEOpage